// @flow
import React from 'react';
import FeatureFlag from '../../features/components/FeatureFlag';
import NotificationButton from './NotificationButton';
import { FEATURES } from '../../features/components/constants';

export default function Notifications(props: any) {
    return (
        <FeatureFlag feature={FEATURES.WEB_NOTIFICATION_CENTER_V1}>
            <NotificationButton {...props} />
        </FeatureFlag>
    );
}
